module.exports = __webpack_public_path__ + "img/Warum.4f965f83.svg";